import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Flex, Box } from 'reflexbox'
import {
    Button,
    Classes,
    Dialog,
    Label,
    TextArea,
    InputGroup,
    Tag,
    MenuItem,
} from '@blueprintjs/core'
import { Select } from '@blueprintjs/select'
import { DateInput, TimePrecision } from '@blueprintjs/datetime'

import { TIMESTAMP_FORMAT } from 'src/utils/reducer'
import { getAction } from 'src/store/modules/runbooks/actions'
import {
    ISSUELOG_SEVERITIES,
    ISSUELOG_PRIORITIES,
    ISSUELOG_STATUSES,
} from 'src/constants/issueLogs'

class AddIssueDialog extends React.Component {
    state = {
        id: null,
        description: '',
        due: new Date(),
        owner: '',
        priority: this.props.priorityChoices[0],
        severity: this.props.severityChoices[0],
        solution: '',
        status: this.props.statusChoices[0],
    }

    componentDidMount() {
        let state = {}
        Object.keys(this.state).forEach((field) => {
            if (this.props[field] !== undefined) {
                state[field] = this.props[field]
            }
        })

        if (state.hasOwnProperty('priority')) {
            state.priority = this.props.priorityChoices.find(
                (choice) => choice[0] === state.priority
            )
        }
        if (state.hasOwnProperty('status')) {
            state.status = this.props.statusChoices.find(
                (choice) => choice[0] === state.status
            )
        }
        if (state.hasOwnProperty('severity')) {
            state.severity = this.props.severityChoices.find(
                (choice) => choice[0] === state.severity
            )
        }
        if (state.hasOwnProperty('due')) {
            state.due = moment(state.due).toDate()
        }

        if (Object.keys(state).length) {
            this.setState(state)
        }
    }

    handleCreateClick = () => {
        this.props.handleConfirm({
            id: this.state.id,
            priority: this.state.priority[0],
            severity: this.state.severity[0],
            status: this.state.status[0],
            due: this.state.due,
            solution: this.state.solution,
            owner: this.state.owner,
            description: this.state.description,
            actionUid: this.props.fromAction,
        })
        this.props.handleClose()
    }

    itemRenderer = (item, { handleClick, modifiers }) => {
        return (
            <MenuItem
                active={modifiers.active}
                key={item[0]}
                onClick={handleClick}
                text={item[1]}
            />
        )
    }

    render() {
        const { handleClose, action } = this.props
        return (
            <Dialog
                onClose={handleClose}
                title="Log an issue"
                isOpen={true}
                canOutsideClickClose={false}
            >
                <div className={Classes.DIALOG_BODY}>
                    {action ? (
                        <React.Fragment>
                            <div style={{ marginBottom: 5 }}>Action</div>
                            <Tag style={{ marginRight: 5 }}>{action.uid}</Tag>
                            <Tag style={{ marginBottom: 15 }} intent="danger">
                                {action.name}
                            </Tag>
                        </React.Fragment>
                    ) : null}
                    <Flex>
                        <Box w={1 / 3}>
                            <Label style={{ padding: '0 5px 0 0' }}>
                                Status
                                <Select
                                    items={this.props.statusChoices}
                                    filterable={false}
                                    itemRenderer={this.itemRenderer}
                                    popoverProps={{
                                        minimal: true,
                                        targetClassName: 'full-width',
                                    }}
                                    onItemSelect={(value) =>
                                        this.setState({ status: value })
                                    }
                                >
                                    <Button
                                        className="full-width"
                                        text={
                                            this.state.status
                                                ? this.state.status[1]
                                                : 'Select status...'
                                        }
                                        rightIcon="double-caret-vertical"
                                        alignText="left"
                                    />
                                </Select>
                            </Label>
                        </Box>
                        <Box w={1 / 3}>
                            <Label style={{ padding: '0 5px' }}>
                                Priority
                                <Select
                                    className="full-width"
                                    items={this.props.priorityChoices}
                                    filterable={false}
                                    itemRenderer={this.itemRenderer}
                                    popoverProps={{
                                        minimal: true,
                                        targetClassName: 'full-width',
                                    }}
                                    onItemSelect={(value) =>
                                        this.setState({ priority: value })
                                    }
                                >
                                    <Button
                                        className="full-width"
                                        text={
                                            this.state.priority
                                                ? this.state.priority[1]
                                                : 'Select priority...'
                                        }
                                        rightIcon="double-caret-vertical"
                                        alignText="left"
                                    />
                                </Select>
                            </Label>
                        </Box>
                        <Box w={1 / 3}>
                            <Label style={{ padding: '0 0 0 5px' }}>
                                Severity
                                <Select
                                    className="full-width"
                                    items={this.props.severityChoices}
                                    filterable={false}
                                    itemRenderer={this.itemRenderer}
                                    popoverProps={{
                                        minimal: true,
                                        targetClassName: 'full-width',
                                    }}
                                    onItemSelect={(value) =>
                                        this.setState({ severity: value })
                                    }
                                >
                                    <Button
                                        className="full-width"
                                        text={
                                            this.state.severity
                                                ? this.state.severity[1]
                                                : 'Select severity...'
                                        }
                                        rightIcon="double-caret-vertical"
                                        alignText="left"
                                    />
                                </Select>
                            </Label>
                        </Box>
                    </Flex>
                    <Label>
                        Due
                        <DateInput
                            showActionsBar={true}
                            timePrecision={TimePrecision.MINUTE}
                            formatDate={(date) =>
                                moment(date).format(TIMESTAMP_FORMAT)
                            }
                            parseDate={(str) =>
                                moment(str, TIMESTAMP_FORMAT).toDate()
                            }
                            placeholder={TIMESTAMP_FORMAT}
                            onChange={(date) => {
                                this.setState({ due: date })
                            }}
                            value={moment(
                                this.state.due,
                                TIMESTAMP_FORMAT
                            ).toDate()}
                        />
                    </Label>
                    <Label>
                        Owner
                        <InputGroup
                            value={this.state.owner}
                            maxLength={128}
                            onChange={(e) =>
                                this.setState({ owner: e.target.value })
                            }
                        />
                    </Label>
                    <Label>
                        Description
                        <TextArea
                            fill={true}
                            onChange={(e) =>
                                this.setState({ description: e.target.value })
                            }
                            value={this.state.description}
                        />
                    </Label>
                    <Label>
                        Solution
                        <TextArea
                            fill={true}
                            onChange={(e) =>
                                this.setState({ solution: e.target.value })
                            }
                            value={this.state.solution}
                            maxLength={128}
                        />
                    </Label>
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button
                            intent="primary"
                            large
                            disabled={!this.isStateValid()}
                            onClick={this.handleCreateClick}
                        >
                            Save
                        </Button>
                        <Button
                            intent="lynch-underline"
                            large
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Dialog>
        )
    }

    isStateValid = () => {
        return !(
            !this.state.owner ||
            !this.state.description ||
            !this.state.solution ||
            !this.state.due ||
            !this.state.priority ||
            !this.state.status ||
            !this.state.severity
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        // TODO: refactor this once actions are asynchronously fetched.
        action: ownProps.fromAction
            ? getAction(
                  state,
                  state.ui.runbook.activeRunbook,
                  ownProps.fromAction
              )
            : null,
        priorityChoices: state.app.issueLogPriorities ?? ISSUELOG_PRIORITIES,
        severityChoices: state.app.issueLogSeverities ?? ISSUELOG_SEVERITIES,
        statusChoices: state.app.issueLogStatuses ?? ISSUELOG_STATUSES,
    }
}

export default connect(mapStateToProps)(AddIssueDialog)
